<template>

  <div id="mySidenav" class="sidenav" :class="{ openSide:leftSidebarVal }">
    <a class="sidebar-overlay" @click="closeLeftBar(leftSidebarVal)"></a>
    <nav>
      <a @click="closeLeftBar(leftSidebarVal)">
        <div class="sidebar-back text-left">
          <i class="ti-close mr-2"></i> <img v-if="signedIn" :src='require("@/assets/images/icon/user.png")' class="mr-2" /> {{firstName}} {{lastName}}
        </div>
      </a>

      <ul id="sub-menu-auth" class="sidebar-menu">

<!--     Signed out   -->

        <template v-if="!signedIn">

          <li>
            <router-link :to="{ path: '/login' }">Sign In</router-link>
          </li>



        </template>

<!--===========  Signed In Web  =============-->

        <template v-if="signed_in_as_web_user && signedIn">

          <li>
            <router-link :to="{ path: '/home' }">Home</router-link>
          </li>

          <li>
            <router-link :to="{ path: '/shop' }">Shop</router-link>
          </li>

          <li>
            <router-link :to="{ path: '/rewards' }">Rewards</router-link>
          </li>

          <li>
            <router-link :to="{ path: '/shop/checkout' }">Checkout</router-link>
          </li>


          <li>
            <router-link :to="{ path: '/account/order-history' }">
              <img :src='require("@/assets/images/icon/history.png")'/>Order History
            </router-link>
          </li>

          <li>
            <router-link :to="{ path: '/FAQ' }">
              <img :src='require("@/assets/images/icon/faq.png")'/>FAQ
            </router-link>
          </li>

          <li>
            <a v-if="signed_in_as_web_user && signedIn" @click="signOut" href="#">
              <img :src='require("@/assets/images/icon/signout.png")'/>Sign Out</a>
          </li>


        </template>


      </ul>
    </nav>
  </div>

</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {signOut} from '@/utils/auth'

export default {
  props: ['leftSidebarVal'],
  data() {
    return {
      activeItem: 'clothing',
    }
  },
  computed:{
    ...mapState({
      app_link: state=>state.cart.app_link,
      firstName: 'auth/getFirstName',
      lastName: 'auth/getLastName',
    }),
    ...mapGetters({
      signedIn:'auth/signedIn',
      signed_in_as_web_user:'auth/webUserAuthed',
      getEnvironment: 'cart/getEnvironment',
    })
  },
  methods: {
    signOut() {
      signOut()
    },
    closeLeftBar(val) {
      val = false
      this.$emit('closeVal', val)
    },
  }
}
</script>
